import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GenericAPIService } from 'src/app/services/generic-api.service';
import { UrlConstants } from 'src/app/constants/url-constants';

@Component({
  selector: 'app-admin-race-prediction',
  templateUrl: './admin-race-prediction.component.html',
  styleUrls: ['./admin-race-prediction.component.scss']
})
export class AdminRacePredictionComponent implements OnInit {

  public raceId: any;
  public raceName: string = '';
  public raceResultId: any;
  public raceEntries: any[] = [];
  public racePredictionsUrl = UrlConstants.racePredictionsList;
  public racesUrl = UrlConstants.racesUrl;
  public PreLoader: boolean = false;
  public race: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private genericService: GenericAPIService
  ) { }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      this.raceId = params['raceId'];
      this.raceName = params['raceName'] || 'Race Prediction';
      this.raceResultId = params['raceResultId'];
      if (this.raceId) {
        this.getRacePredictions();
        this.getRaceInfo();
      }
    });
  }

  getRaceInfo() {
    this.genericService.getAll(this.racesUrl).subscribe(response => {
      if (response.status.success === 'Success') {
        const races = response.data;
        this.race = races.find(r => r.RaceResult.raceId == this.raceId);
        if (this.race) {
          this.race.isUpdate = this.isUpdate(this.race);
        }
      }
    });
  }

  isUpdate(race) {
    const raceEndDateAndTime = new Date(race.RaceResult.date);
    const now = new Date();
    return now < raceEndDateAndTime ? "update" : "updated";
  }

  getRacePredictions() {
    this.PreLoader = true;
    const url = `${this.racePredictionsUrl}?raceId=${this.raceId}`;
    this.genericService.getAll(url).subscribe(response => {
      if (response.status.success === 'Success') {
        this.raceEntries = response.data;
        this.raceEntries.sort((a, b) => {
          const nameA = a.userName.toLowerCase();
          const nameB = b.userName.toLowerCase();
          if (nameA < nameB) return -1;
          if (nameA > nameB) return 1;
          return 0;
        });
      }
      this.PreLoader = false;
    }, error => {
      this.PreLoader = false;
      console.error('Error fetching race predictions', error);
    });
  }

  editPrediction(entry) {
    // if (this.race && this.race.isUpdate === 'update') {
      this.genericService.router.navigate(['/admin/updateUserPrediction'], {
        queryParams: {
          userId: entry.userId,
          raceId: this.raceId
        }
      });
    }
  // }

}
